import { render } from "./Form.vue?vue&type=template&id=46ab4146"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=46ab4146&lang=scss"

import exportComponent from "/var/www/sites/qiyas.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__